import siderTrigger from './sider-trigger.vue'
export default siderTrigger



// WEBPACK FOOTER //
// ./src/view/main/components/header-bar/sider-trigger/index.js